import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Loader2, MailCheck, Send } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { AuthShell, formatApiErrorDetail } from "../components/AuthShell";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { identifier: identifier.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell>
      <Link to="/login" className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-900 mb-6" data-testid="back-to-login-link">
        <ArrowLeft className="w-3.5 h-3.5" /> Επιστροφή στη σύνδεση
      </Link>
      <h2 className="text-base md:text-lg font-semibold text-slate-900">Επαναφορά κωδικού</h2>
      <p className="text-sm text-slate-500 mt-1 mb-8">Δώστε το όνομα χρήστη ή το email σας. Θα σας στείλουμε σύνδεσμο για να ορίσετε νέο κωδικό.</p>
      {sent ? (
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-5 flex gap-3" data-testid="forgot-success">
          <MailCheck className="w-6 h-6 text-emerald-600 shrink-0" />
          <div className="text-sm text-emerald-900">
            <p className="font-semibold">Ελέγξτε το email σας</p>
            <p className="mt-1">Αν τα στοιχεία αντιστοιχούν σε λογαριασμό με καταχωρημένο email, θα λάβετε σύνδεσμο επαναφοράς σε λίγα λεπτά. Ο σύνδεσμος ισχύει για 60 λεπτά.</p>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="identifier" className="text-slate-700">Όνομα Χρήστη ή Email</Label>
            <Input id="identifier" value={identifier} onChange={(e) => setIdentifier(e.target.value)} required className="h-11"
              placeholder="π.χ. username ή onoma@dikastirio.gr" autoComplete="username" data-testid="forgot-identifier-input" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
          <Button type="submit" disabled={loading || !identifier.trim()} className="w-full h-11 bg-slate-900 hover:bg-slate-800" data-testid="forgot-submit-btn">
            {loading ? <Loader2 className="w-5 h-5 mr-2 animate-spin" /> : <Send className="w-5 h-5 mr-2" />} Αποστολή συνδέσμου
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
